import React from 'react';
import PropTypes from 'prop-types';
import { toDateString } from '../../../utils/date';
import styles from './OtherImageryEvent.css';

function OtherImageryEvent({
  active,
  date,
  handleSelectEvent = () => {},
  name,
  locale = 'en-US',
}) {
  const otherImageryClasses = active
    ? `${styles.event} ${styles.active}`
    : styles.event;

  const keyClasses = active ? `${styles.key} ${styles.active}` : styles.key;

  return (
    <div
      className={otherImageryClasses}
      data-test-id="dmb-other-imagery-event"
      onClick={handleSelectEvent}
      role="button"
      tabIndex={0}
    >
      <div className={keyClasses}>{name}</div>
      <div className={styles.date}>{toDateString(date, locale)}</div>
    </div>
  );
}

OtherImageryEvent.propTypes = {
  active: PropTypes.bool,
  date: PropTypes.string.isRequired,
  handleSelectEvent: PropTypes.func,
  locale: PropTypes.string,
  name: PropTypes.string.isRequired,
};

export default OtherImageryEvent;
